module.exports = __webpack_public_path__ + "img/katarina_events_5.fe56b5e5.jpg";